var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"ma-0"},[_c('vue-skeleton-loader',{staticClass:"mt-1",attrs:{"width":160,"height":40}}),_c('vue-skeleton-loader',{staticClass:"mt-2",attrs:{"width":220,"height":15}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }